import { PaymentSettings } from "../assets/interfaces/commom_interfaces";
import { OutletInterface, StoreDineInOrder } from "../assets/interfaces/FX_POS_Interfaces";

export const CLIENT_ID = "CLIENT_ID";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const OUTLET_LIST = "OUTLET_LIST"
export const RESET_STATE = "RESET_STATE"
export const OUTLET_ID = "OUTLET_ID"
export const ME_DETAILS = "ME_DETAILS"
export const DINE_IN_ORDER_UPDATE = "DINE_IN_ORDER_UPDATE"
export const SET_PAYMENT_SETTINGS_FETCHED = "SET_PAYMENT_SETTINGS_FETCHED"
export const SAVE_PAYMENT_SETTINGS = "SAVE_PAYMENT_SETTINGS"

export const resetState = () => ({
  type: "RESET_STATE",
});

export const accessToken = (access_token: string) => ({
  type: ACCESS_TOKEN,
  payload: access_token,
});
export const storeClientId = (payload: string) => ({
  type: CLIENT_ID,
  payload: payload,
})
export const storeMeDetails = (payload: string) => ({
  type: ME_DETAILS,
  payload: payload,
})
export const storeSelectedOutlet = (payload: OutletInterface[]) => ({
  type: OUTLET_ID,
  payload: payload,
})
export const storeOutlets = (outlets: OutletInterface[]) => ({
  type: OUTLET_LIST,
  payload: outlets,
})

export const DineInCartUpdate = (flag: boolean) => ({
  type: DINE_IN_ORDER_UPDATE,
  payload: flag,
})
export const setPaymentSettingFetched = (flag: boolean) => ({
  type: SET_PAYMENT_SETTINGS_FETCHED,
  payload: flag,
})
export const savePaymentSettings = (payload: PaymentSettings) => ({
  type: SAVE_PAYMENT_SETTINGS,
  payload: payload,
})
